import { useEffect } from 'react';
import { atom } from 'jotai/index';
import { useAtom } from 'jotai';

type TDirection = 'ltr' | 'rtl';

export const localeToDir = (locale: string): TDirection => {
  switch (locale) {
    case 'ar':
    case 'he':
    case 'iw':
      return 'rtl';
    default:
      return 'ltr';
  }
};

export const directionAtom = atom<TDirection>('ltr');
directionAtom.debugLabel = 'DirectionAtom';

export const useBidiSupport = ({
  locale,
  elementToUpdate,
}: {
  locale?: string | null;
  elementToUpdate: string;
}) => {
  const [dir, setDir] = useAtom(directionAtom);

  useEffect(() => {
    if (!locale || !document.body) {
      return;
    }

    const element = document.querySelector(elementToUpdate);
    if (!element) {
      return;
    }

    const _dir = localeToDir(locale);
    setDir(_dir);

    element.setAttribute('dir', _dir);

    return () => {
      element.removeAttribute('dir');
    };
  }, [elementToUpdate, locale]);

  return {
    dir,
  };
};
